/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Media Import" |
*
* @param {Media_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_title = /** @type {((inputs?: Media_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des medias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de mídia")
	return /** @type {LocalizedString} */ ("Media Import")
});